import { inferRouteObject } from 'react-router-typed-object';

import { Outlet } from '@/js/libs/router';
import { PrivateRoute, Roles, or } from '@/js/libs/use-auth';

import { DEV_MODE } from 'src/constants.ts';
import { bulkUploadNativeRouterSearchParamsSchema } from 'src/scenes/Creatives/containers/Digital/containers/BulkUploadNative/schema.ts';
import { creativeFormRouterSearchParamsSchema } from 'src/scenes/Creatives/containers/Digital/containers/CreativeForm/schema.ts';
import { digitalCreativesRouterSearchParamsSchema } from 'src/scenes/Creatives/containers/Digital/schema.ts';
import Creatives from 'src/scenes/Creatives/index.ts';
import Status from 'src/scenes/Status/index.ts';

const index = true;

export const creativesRouteObject = inferRouteObject({
  path: 'creatives',
  element: (
    <PrivateRoute
      roles={or(Roles.ADSERVER_CREATIVES, Roles.MANAGE_DIGITAL_CREATIVES, Roles.MANAGE_PRINT_CREATIVES, Roles.ADMIN)}
      noAccessComponent={Status.NotFound}
    />
  ),
  children: [
    {
      Component: Creatives.Helmet,
      children: [
        {
          path: 'digital',
          element: <PrivateRoute roles={Roles.MANAGE_DIGITAL_CREATIVES} noAccessComponent={Status.NotFound} />,
          children: [
            {
              Component: Creatives.Digital.Providers,
              children: [
                {
                  path: 'bulk-upload',
                  element: <PrivateRoute roles={Roles.ADMIN} noAccessComponent={Status.NotFound} />,
                  searchParams: bulkUploadNativeRouterSearchParamsSchema.parse,
                  children: [{ index, Component: Creatives.Digital.BulkUploadNative }],
                },
                { index, Component: Creatives.Digital.CreativesList },
              ],
            },
            {
              path: 'create',
              Component: Creatives.Digital.CreativeForm,
              searchParams: creativeFormRouterSearchParamsSchema.parse,
            },
            { path: ':creativeId/edit', Component: Creatives.Digital.CreativeForm },
            { path: ':creativeId/history', Component: Creatives.Digital.CreativeHistory },
          ],
          searchParams: digitalCreativesRouterSearchParamsSchema.parse,
        },
        {
          path: 'print',
          element: <PrivateRoute roles={Roles.MANAGE_PRINT_CREATIVES} noAccessComponent={Status.NotFound} />,
          children: [
            { index, Component: Creatives.Print.CreativesList },
            { path: 'create', Component: Creatives.Print.CreativeForm },
            { path: ':creativeId', Component: Creatives.Print.CreativeForm },
          ],
        },
        {
          path: 'ad-server',
          element: <PrivateRoute roles={Roles.ADSERVER_CREATIVES} noAccessComponent={Status.NotFound} />,
          children: [
            { index, Component: Creatives.AdServer.CreativesList },
            { path: ':creativeId', Component: Creatives.AdServer.CreativeDetails },
          ],
        },
        {
          path: 'templates',
          element: <PrivateRoute roles={Roles.MANAGE_DIGITAL_CREATIVES} noAccessComponent={Status.NotFound} />,
          children: [
            { index, Component: Creatives.Templates.TemplatesList },
            { path: 'create', Component: Creatives.Templates.TemplateForm },
            { path: ':templateId/edit', Component: Creatives.Templates.TemplateForm },
          ],
        },
        {
          path: 'content',
          element: DEV_MODE ? <Outlet /> : <Status.NotFound />,
          children: [{ path: 'editor', Component: Creatives.Content.Editor }],
        },
        {
          path: 'ad-quality-reports',
          element: <PrivateRoute roles={Roles.ADMIN} noAccessComponent={Status.NotFound} />,
          children: [
            { index, Component: Creatives.AdQualityReports.LatestReport },
            { path: 'history', Component: Creatives.AdQualityReports.ReportList },
            { path: ':reportId', Component: Creatives.AdQualityReports.ReportDetails },
          ],
        },
        {
          path: 'ad-quality-dashboard',
          element: <PrivateRoute roles={Roles.ADMIN} noAccessComponent={Status.NotFound} />,
          children: [{ index, Component: Creatives.AdQualityReports.Dashboard }],
        },
        {
          index,
          Component: Creatives.RoleBasedRedirector,
        },
      ],
    },
  ],
});
